import {
    isTodoFolderDescriptor,
    isTodoMyDayDescriptor,
    isTodoDueDateDescriptor,
} from '../typeGuards';
import type { TodoDescriptor } from '../../schema/TodoDescriptor';
import { assertNever } from 'owa-assert';

export function getCustomQueryOptions(descriptor: TodoDescriptor) {
    const { maxCount } = descriptor;
    let customQueryOptions = {};
    if (maxCount) {
        customQueryOptions = { maxPageSize: maxCount };
    }

    if (isTodoFolderDescriptor(descriptor)) {
        return customQueryOptions;
    } else if (isTodoMyDayDescriptor(descriptor)) {
        return {
            ...customQueryOptions,
            date: descriptor.date,
        };
    } else if (isTodoDueDateDescriptor(descriptor)) {
        return {
            ...customQueryOptions,
            startDate: descriptor.startDate,
            endDate: descriptor.endDate,
        };
    }
    return assertNever(descriptor);
}
